'use client'

import type { ReactNode } from 'react'

import Button from 'react-bootstrap/Button'

interface EnquiryButtonProps {
  text: ReactNode
  email: string
  subject: string
  body: string
}

function EnquiryButton({ text, email, subject, body }: EnquiryButtonProps) {
  const handleClick = () => {
    window.location.href = `mailto:${email}?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`
  }

  return (
    <>
      <style type="text/css">
        {`
          .btn-enquiry {
            color: white;
            background: linear-gradient(45deg, #070097 0%, #211AFB 100%);
            padding: 15px 40px;
            font-size: 14px;
            border: 1px solid var(--gradient-brand-80060045-deg, #070097);            
            border-radius: 5px;
            font-size: 16px;
            font-weight: 500;
            box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
          }
          .btn-enquiry:hover {
            color: white;
          }
        `}
      </style>

      <Button variant="enquiry" onClick={handleClick}>
        {text}
      </Button>
    </>
  )
}

export default EnquiryButton
